// extracted by mini-css-extract-plugin
export default {"wrapper":"jo-z","addressLine":"ko-z","fullName":"lo-z"};